import { apiRegistry } from '../../../common/infra/apiRegistry'
import { searchHistoryMem } from '../mem/searchHistoryMem'

apiRegistry.registerGetApi('getSearchHistory', async () => {
  return { history: [...searchHistoryMem].reverse() }
})
